export default __webpack_public_path__ + "static/media/lattice-logo.2bc3cd2d.png";